export function UserIcon({ className }) {
  return (
    <svg
      className={className || "h-6 w-6"}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.7146 15.8932C13.4635 14.2421 11.4813 13.1755 9.24999 13.1755C7.01867 13.1755 5.03646 14.2421 3.78538 15.8932M14.7146 15.8932C16.4065 14.3872 17.4722 12.1928 17.4722 9.74957C17.4722 5.20856 13.791 1.52734 9.24999 1.52734C4.70899 1.52734 1.02777 5.20856 1.02777 9.74957C1.02777 12.1928 2.09346 14.3872 3.78538 15.8932M14.7146 15.8932C13.262 17.1862 11.3477 17.9718 9.24999 17.9718C7.15226 17.9718 5.23801 17.1862 3.78538 15.8932M11.9907 7.69401C11.9907 9.20768 10.7637 10.4348 9.24999 10.4348C7.73632 10.4348 6.50925 9.20768 6.50925 7.69401C6.50925 6.18034 7.73632 4.95327 9.24999 4.95327C10.7637 4.95327 11.9907 6.18034 11.9907 7.69401Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function UsersIcon({ className }) {
  return (
    <svg
      className={className || "h-6 w-6"}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.25 12.6499V16.9C18.25 17.9944 17.4631 18.9359 16.3782 19.08C14.2915 19.357 12.1624 19.5 10 19.5C7.83757 19.5 5.70854 19.357 3.62185 19.08C2.5369 18.9359 1.75 17.9944 1.75 16.9V12.6499M18.25 12.6499C18.7219 12.2476 19 11.6389 19 10.9889V7.20569C19 6.12475 18.2321 5.19082 17.1631 5.03086C16.0377 4.86247 14.8995 4.73315 13.75 4.64432M18.25 12.6499C18.0564 12.815 17.8302 12.9453 17.5771 13.0294C15.1953 13.8212 12.6477 14.25 10 14.25C7.35229 14.25 4.80469 13.8212 2.42289 13.0294C2.16984 12.9452 1.94361 12.8149 1.75 12.6499M1.75 12.6499C1.27808 12.2476 1 11.6389 1 10.9889V7.20569C1 6.12475 1.7679 5.19082 2.83694 5.03086C3.96233 4.86247 5.10049 4.73315 6.25 4.64432M13.75 4.64432V3.75C13.75 2.50736 12.7426 1.5 11.5 1.5H8.5C7.25736 1.5 6.25 2.50736 6.25 3.75V4.64432M13.75 4.64432C12.5126 4.5487 11.262 4.5 10 4.5C8.73804 4.5 7.48744 4.5487 6.25 4.64432M10 11.25H10.0075V11.2575H10V11.25Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function PackageIcon({ className }) {
  return (
    <svg
      className={className || "h-6 w-6"}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 4.62803V3.75C4 2.50736 5.00736 1.5 6.25 1.5H13.75C14.9926 1.5 16 2.50736 16 3.75V4.62803M4 4.62803C4.23458 4.54512 4.48702 4.5 4.75 4.5H15.25C15.513 4.5 15.7654 4.54512 16 4.62803M4 4.62803C3.12611 4.93691 2.5 5.77034 2.5 6.75V7.62803M16 4.62803C16.8739 4.93691 17.5 5.77034 17.5 6.75V7.62803M17.5 7.62803C17.2654 7.54512 17.013 7.5 16.75 7.5H3.25C2.98702 7.5 2.73458 7.54512 2.5 7.62803M17.5 7.62803C18.3739 7.93691 19 8.77034 19 9.75V15.75C19 16.9926 17.9926 18 16.75 18H3.25C2.00736 18 1 16.9926 1 15.75V9.75C1 8.77034 1.62611 7.93691 2.5 7.62803"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgMapPin({ className }) {
  return (
    <svg
      className={className || "h-6 w-6"}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.08 8.7C11.08 10.2906 9.79058 11.58 8.2 11.58C6.60942 11.58 5.32 10.2906 5.32 8.7C5.32 7.10942 6.60942 5.82 8.2 5.82C9.79058 5.82 11.08 7.10942 11.08 8.7Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4 8.7C15.4 15.5565 8.2 19.5 8.2 19.5C8.2 19.5 1 15.5565 1 8.7C1 4.72355 4.22355 1.5 8.2 1.5C12.1764 1.5 15.4 4.72355 15.4 8.7Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgHourglass({ className }) {
  return (
    <svg
      className={className || "h-6 w-6"}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      viewBox="0 0 24 24"
    >
      <path d="M5 22h14" />
      <path d="M5 2h14" />
      <path d="M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22" />
      <path d="M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2" />
    </svg>
  );
}

export function SvgFileUp({ className }) {
  return (
    <svg
      className={className || "h-6 w-6"}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      viewBox="0 0 24 24"
    >
      <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
      <path d="M14 2v4a2 2 0 0 0 2 2h4" />
      <path d="M12 12v6" />
      <path d="m15 15-3-3-3 3" />
    </svg>
  );
}

export function SvgCalendar({ className }) {
  return (
    <svg
      className={className || "h-6 w-6"}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      viewBox="0 0 24 24"
    >
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  );
}

export function MediaIcon({ className }) {
  return (
    <svg
      className={className || "h-6 w-6"}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      viewBox="0 0 24 24"
    >
      <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18" />
      <path d="M7 2v20M17 2v20M2 12h20M2 7h5M2 17h5M17 7h5M17 17h5" />
    </svg>
  );
}

export function DiscountIcon({ className }) {
  return (
    <svg
      className={className || "h-6 w-6"}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      <path
        d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0zM12 9v4M12 17h.01"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ChartIcon({ className }) {
  return (
    <svg
      className={className || "h-6 w-6"}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 3V15M10 5V19M6 7V17M18 9V13"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CrownIcon({ className, fill }) {
  return (
    <svg
      className={className || "h-6 w-6"}
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fill}
        d="M2.53587 9.56118L2.72777 10.3309C2.96112 11.2887 3.48442 11.7756 4.48317 11.7756H10.809C11.8116 11.7756 12.3301 11.2983 12.5692 10.3309L12.7611 9.56118H2.53587ZM2.31489 8.64496H12.9869L14.0474 4.30632L13.3597 3.9385L10.7805 5.79873C10.6041 5.922 10.4835 5.87787 10.3842 5.73605L7.88258 2.02492L7.41443 2.01536L4.90212 5.73885C4.81235 5.87484 4.70613 5.91523 4.52974 5.79091L1.99458 3.96045L1.23992 4.2755L2.31489 8.64496ZM1.47268 5.42005C2.28512 5.42005 2.93952 4.76087 2.93952 3.94259C2.93952 3.13971 2.28512 2.47575 1.47268 2.47575C0.659181 2.47575 0 3.13493 0 3.94259C0 4.76087 0.663968 5.42005 1.47268 5.42005ZM7.648 2.93952C8.45562 2.93952 9.11484 2.28034 9.11484 1.46684C9.11484 0.663968 8.45562 0 7.648 0C6.82968 0 6.1753 0.659181 6.1753 1.46684C6.1753 2.28034 6.83553 2.93952 7.648 2.93952ZM13.8122 5.42005C14.6188 5.42005 15.2838 4.76087 15.2838 3.94259C15.2838 3.13493 14.6236 2.47575 13.8122 2.47575C13.0035 2.47575 12.3443 3.13971 12.3443 3.94259C12.3443 4.76087 13.0035 5.42005 13.8122 5.42005Z"
      />
    </svg>
  );
}

export function MonitorIcon({ className }) {
  return (
    <svg
      className={className || "h-6 w-6"}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      viewBox="0 0 24 24"
    >
      <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
      <line x1="8" y1="21" x2="16" y2="21" />
      <line x1="12" y1="17" x2="12" y2="21" />
    </svg>
  );
}

export function VipStarIcon({ className, fill }) {
  return (
    <svg
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || "h-6 w-6"}
    >
      <path
        fill={fill}
        d="M2.45995 12.1364C2.72632 12.3433 3.06151 12.2755 3.44546 11.9956L6.40873 9.81651L9.37463 11.9956C9.76063 12.2755 10.0901 12.3433 10.3612 12.1364C10.6265 11.9352 10.6829 11.6047 10.5292 11.156L9.35807 7.67427L12.3478 5.52571C12.7328 5.2525 12.8926 4.95457 12.7871 4.63283C12.6827 4.3194 12.38 4.17197 11.9055 4.17197H8.23883L7.12466 0.694872C6.97667 0.237434 6.74392 0 6.40873 0C6.07717 0 5.84442 0.237434 5.69643 0.694872L4.58228 4.17197H0.914567C0.441068 4.17197 0.138465 4.3194 0.03399 4.6318C-0.0772072 4.95457 0.0883358 5.2525 0.473311 5.52571L3.46301 7.67427L2.2919 11.156C2.13821 11.6047 2.19563 11.9352 2.45995 12.1364Z"
      />
    </svg>
  );
}
